import { ForestProductMemberLayout } from '../../../components/ForestProduct';
import { usePageTitle } from '../../../hooks';

export function ForestProduct() {
  usePageTitle('navigation:sections.forestProducts');
  return <ForestProductMemberLayout />;
}
